import React, { useEffect, useState } from "react";
import BorderedButton from "../../../Buttons/BorderedButton";
import PrimaryButton from "../../../Buttons/PrimaryButton";
import styles from "./Style.module.css";
import CustomRadio from "../../../CustomRadio/CustomRadio";
import { useGlobalContext } from "../../../../Context/GlobalContext";

const CancelRepearBookingStep = ({ onClose, onConfirm, error }) => {
	const { selectedBookingDeleteScope, setSelectedBookingDeleteScope } = useGlobalContext();
	const [selected, setSelected] = useState(selectedBookingDeleteScope || "this_only");
	

	useEffect(() => {
		setSelectedBookingDeleteScope(selected);
	}, [selected, setSelectedBookingDeleteScope]);


	const handleChange = (e) => {
		const value = e.target.value;
		setSelected(value);
	};

	return (
		<div className={`${styles.cancelStep} popup`}>	
			<div className="header">
				<h2>Cancel / Delete Appointment</h2>
				<p>Please select the cancellation type.</p>
			</div>

			<div className="body">
				<div className={styles.groupInput}>
					<CustomRadio
						label="This Appointment "
						name="customRadio"
						value="this_only"
						checked={selected === "this_only"}
						onChange={handleChange}
					/>
					<CustomRadio
						label="All Future Appointments"
						name="customRadio"
						value="this_and_future"
						checked={selected === "this_and_future"}
						onChange={handleChange}
					/>
				</div>
				{error && <p className={`${styles.errorText} common-error-message`}>{error}</p>}
			</div>

			<div className="footer">
				<BorderedButton 
					text="Cancel" 
					onClick={onClose} 
				/>

				<PrimaryButton
					text="Next"
					onClick={() => onConfirm(selected)}
				/>
				
			</div>
		</div>
	);
};

export default CancelRepearBookingStep;
